// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/super_offers/components/index.css
// module id = 1738
// module chunks = 0